export default __webpack_public_path__ + "static/media/illustration-study-2-w@3x.fae4a11c.png";